<template>
  <div>
    <div class="container">
      <div class="row justify-content-center mt-4">
        <div class="col-md-4" v-for="i in count" :key="i">
          <div class="exams-box">
            <div class="img-container" style="position: relative;">
              <VueSkeletonLoader type="rect" :width="260" :height="163" rounded animation="fade" color="#dddddd" />
              <VueSkeletonLoader type="rect" :width="70" :height="24"
                style="position: absolute; right: 10px; top: 10px; border-radius: 5px;" animation="fade"
                color="#ffe082" />
            </div>
            <div class="container">
              <div class="course-card-title description mt-2">
                <h4 class="course-title">
                  <VueSkeletonLoader type="rect" :width="120" :height="12" rounded animation="fade" color="#dddddd"
                    style="margin-bottom: 7px;" />
                  <VueSkeletonLoader type="rect" :width="180" :height="18" rounded animation="fade" color="#dddddd"
                    style="margin-bottom: 7px;" />
                  <VueSkeletonLoader type="rect" :width="100" :height="10" rounded animation="fade" color="#dddddd" />
                </h4>
              </div>
              <div class="wrapper-r">
                <div class="details-cntr">
                  <div class="course-card-details-container all-items">
                    <div class="row gap-4 details-flex-row">
                      <div class="details-width">
                        <div class="course-card-details">
                          <span class="details-count d-flex">
                            <VueSkeletonLoader type="circle" :width="20" :height="20" animation="fade" color="#dddddd"
                              style="margin-right: 4px;" />
                            <VueSkeletonLoader type="rect" :width="30" :height="12" animation="fade" color="#dddddd"
                              style="margin-top: 5px;" />
                          </span>
                        </div>
                      </div>
                      <div class="details-width">
                        <div class="course-card-details">
                          <span class="details-count d-flex">
                            <VueSkeletonLoader type="circle" :width="20" :height="20" animation="fade" color="#dddddd"
                              style="margin-right: 4px;" />
                            <VueSkeletonLoader type="rect" :width="30" :height="12" animation="fade" color="#dddddd"
                              style="margin-top: 5px;" />
                          </span>
                        </div>
                      </div>
                      <div class="details-width">
                        <div class="course-card-details">
                          <span class="details-count d-flex">
                            <VueSkeletonLoader type="circle" :width="20" :height="20" animation="fade" color="#dddddd"
                              style="margin-right: 4px;" />
                            <VueSkeletonLoader type="rect" :width="30" :height="12" animation="fade" color="#dddddd"
                              style="margin-top: 5px;" />
                          </span>
                        </div>
                      </div>
                      <div class="details-width">
                        <div class="course-card-details">
                          <span class="details-count d-flex">
                            <VueSkeletonLoader type="circle" :width="20" :height="20" animation="fade" color="#dddddd"
                              style="margin-right: 4px;" />
                            <VueSkeletonLoader type="rect" :width="30" :height="12" animation="fade" color="#dddddd"
                              style="margin-top: 5px;" />
                          </span>
                        </div>
                      </div>
                      <div class="details-width">
                        <div class="course-card-details">
                          <span class="details-count d-flex">
                            <VueSkeletonLoader type="circle" :width="20" :height="20" animation="fade" color="#dddddd"
                              style="margin-right: 4px;" />
                            <VueSkeletonLoader type="rect" :width="30" :height="12" animation="fade" color="#dddddd"
                              style="margin-top: 5px;" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="course-btn-cntr-2">
              <!-- <VueSkeletonLoader type="rect" :width="120" :height="36" rounded animation="fade" color="#dddddd" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSkeletonLoader from "skeleton-loader-vue";
export default {
  props: ["count"],
  components: {
    VueSkeletonLoader,
  },
};
</script>
<style scoped>
.exams-box {
  position: relative;
  border-radius: 16px;
  max-width: 260px;
  margin: 20px auto;
  border: none !important;
  box-shadow: 0px 10px 30px rgba(0, 85, 129, 0.15);
}

.exams-box .img-container img,
.exams-box .img-container .VueSkeletonLoader {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  height: 163px !important;
}

.exams-box .trial-badge {
  position: absolute;
  right: 10px;
  top: 10px;
  color: #fff;
  background-color: var(--yellow);
  padding: 5px 10px;
  font-size: 0.778rem;
  border-top-left-radius: 0px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 5px;
}

.exams-box .course-btn-cntr-2 {
  color: black;
  padding: 10px 0px;
  text-align: center;
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
}

.details-count.d-flex {
  display: flex;
  align-items: left;
  gap: 3px;
}
</style>
